const appSettingsModule = angular.module('appSettingsModule', []);

export default appSettingsModule.name;